import { GeneralDisplayDataTypes } from "@/types/displayData/GeneralDisplayDataTypes";
import { TypeUser } from "../types/UtilisateurType";

export const GENERAL_DATA: GeneralDisplayDataTypes = {
    actualites: {
      title: "Actualités et événements",
      subtitle: "Les dernières actions sur le terrain",
      description:
        "Le secteur de l’élevage au Sénégal est en constante évolution grâce à des efforts concertés et des actions novatrices...",
      news: [
        {
          title: "Journées de sensibilisation et foires agricoles",
          description: "Ces événements rassemblent les éleveurs, les décideurs, et les partenaires...",
          image: "/assets/images/foire.png",
          link: "#",
        },
        {
          title: "Sensibilisation sur la vaccination",
          description: "La santé animale est un pilier central de notre mission...",
          image: "/assets/images/vaccin.png",
          link: "#",
        },
        {
          title: "Formations et Ateliers",
          description: "Nous organisons des formations pour renforcer les capacités des éleveurs...",
          image: "/assets/images/atelier.png",
          link: "#",
        },
      ],
    },
  
    avantages: {
      title: "Nous assurons la prospérité du cheptel",
      subtitle: "Pourquoi choisir notre solution ?",
      imageSrc: "/assets/images/cheptel1.png",
      features: [
        {
          title: "Précision et Fiabilité",
          description: "Notre solution repose sur des technologies de pointe adaptées aux réalités du Sénégal. Grâce à des outils numériques innovants, nous garantissons un suivi exact des troupeaux, quel que soit leur emplacement. Les données collectées sont fiables et exploitables pour une gestion optimale.",
        },
        {
          title: "Gain de temps",
          description: "Dans un contexte où le secteur de l'élevage est crucial pour l'économie sénégalaise, notre plateforme réduit considérablement le temps nécessaire au recensement des animaux. Les éleveurs et les agents de recensement peuvent désormais effectuer leurs tâches de manière rapide et sans tracas, même dans les zones les plus reculées.",
        },
        {
          title: "Décision Informée",
          description: "Les données générées par notre système permettent aux décideurs publics de mieux comprendre les dynamiques du cheptel au Sénégal. Cela inclut la répartition géographique des troupeaux, leur état sanitaire et leur croissance, offrant ainsi une base solide pour élaborer des politiques efficaces et durables.",
        },
      ],
    },
  
    etapes: {
      title: "Comment ça marche ?",
      subtitle: "Une démarche simple pour des résultats rapides",
      steps: [
        {
          number: "1",
          title: "Enregistrement",
          description: "L' inscription est rapide et facile, accessible aussi bien aux éleveurs qu'aux agents de recensement. Une fois enregistrés, les utilisateurs obtiennent un accès personnalisé à l’ensemble des outils et fonctionnalités de la solution",
          backgroundColor: "#f5f3eb",
          textColor: "#000000",
        },
        {
          number: "2",
          title: "Collecte des données",
          description: "Nos outils incluent des formulaires numériques pour saisir des données comme le nombre d'animaux, leurs caractéristiques (espèce, âge, état de santé) et leur emplacement géographique. ",
          backgroundColor: "#0C0C0C",
          textColor: "#FFFFFF",
        },
        {
          number: "3",
          title: "Analyse et visualisation",
          description: "Une fois les données collectées, la plateforme génère des rapports détaillés et personnalisés. Nos rapports offrent une vue d’ensemble sur le cheptel, des tendances, et des alertes en cas de problèmes détectés (maladies, zones à risque). ",
          backgroundColor: "#0027A7",
          textColor: "#FFFFFF",
        },
        {
          number: "4",
          title: "Action et Suivi",
          description: "Grâce aux informations fournies, l’état prendra des décisions éclairées, qu'il s'agisse de planifier des campagnes de vaccination, d'optimiser les ressources disponibles, ou d'anticiper les besoins en fonction des tendances observées.",
          backgroundColor: "#FFC700",
          textColor: "#000000",
        },
      ],
    },
  
    force: {
      features: [
        {
          title: "Précision et Fiabilité",
          description: "Une technologie avancée pour un suivi exact des troupeaux.",
        },
        {
          title: "Gain de temps",
          description: "Simplifiez et accélérez le processus de recensement.",
        },
        {
          title: "Décision informée",
          description: "Des données claires pour orienter les politiques et stratégies d'élevage du cheptel.",
        },
      ],
    },
  
    impact: {
      title: "Impact pour le Sénégal 🇸🇳",
      subtitle: "Une transformation durable pour l’élevage et l’économie rurale",
      sections: [
        {
          title: "Amélioration des politiques d’élevage",
          description: "En disposant de données fiables et actualisées, les décideurs peuvent mieux planifier et exécuter des politiques agricoles adaptées. Cela inclut la gestion des ressources, la régulation du cheptel et le développement d'infrastructures spécifiques pour soutenir les éleveurs dans les régions les plus isolées. Ces politiques, basées sur des informations précises, renforcent la résilience du secteur face aux défis climatiques et économiques.",
        },
        {
          title: "Soutien aux éleveurs",
          description: "Les éleveurs sénégalais bénéficient directement de la simplification des processus de recensement et de gestion. Avec un accès facilité à des informations pertinentes, ils peuvent optimiser leurs activités, anticiper les besoins en alimentation et en soins vétérinaires, et mieux valoriser leurs produits sur les marchés locaux et internationaux. Cette solution les aide également à obtenir un appui financier ou technique plus rapidement, grâce à des données concrètes sur leurs exploitations.",
        },
        {
          title: "Réduction des pertes",
          description: "Une des principales causes de pertes dans l'élevage au Sénégal est le manque de réactivité face aux crises, qu'elles soient sanitaires ou environnementales. En offrant un suivi en temps réel et une visibilité sur l'ensemble du cheptel, notre solution permet de réagir rapidement pour limiter les dégâts. Les maladies peuvent être détectées plus tôt, les ressources allouées efficacement, et les zones à risque identifiées à l’avance, contribuant ainsi à une réduction significative des pertes.",
        },
      ],
      images: ["/assets/images/agriculture.png"],
    },
  
    partenariats: {
      title: "Partenariats Stratégiques",
      subtitle: "Ensemble pour un élevage durable au Sénégal",
      description:
        "Notre solution repose sur des partenariats stratégiques avec les principaux acteurs du secteur...",
      partners: [
        { name: "République du Sénégal", logo: "/assets/images/logosenegal.png" },
        { name: "Sénégal Service", logo: "/assets/images/senegalservice.png" },
        { name: "Ministère de l'Élevage", logo: "/assets/images/ministereelevage.png" },
        { name: "MASAE", logo: "/assets/images/masae.png" },
      ],
    },
  
    presentation: {
      hero: {
        title: "Optimisez la gestion du cheptel au Sénégal",
        description:
          "Une plateforme digitale innovante, soutenue par l'État du Sénégal, qui transforme le recensement du cheptel en un processus rapide, fiable et accessible à tous les éleveurs et agriculteurs. Grâce à des données actualisées en temps réel, cette solution facilite la prise de décision stratégique, améliore le développement du Cheptel et contribue ainsi au développement durable et à la modernisation de l'élevage au Sénégal.",
      },
      features: [
        {
          title: "Précision et Fiabilité",
          description: "Une technologie avancée pour un suivi exact des troupeaux.",
        },
        {
          title: "Gain de temps",
          description: "Simplifiez et accélérez le processus de recensement.",
        },
        {
          title: "Décision informée",
          description: "Des données claires pour orienter les politiques et stratégies d'élevage du cheptel.",
        },
      ]
    },
  
    services: {
      sectionHeader: "Nos fonctionnalités clés",
      sectionMainTitle: "Une gestion optimisée et fiable",
      sectionDescription:
        "Un allié L’objectif principal est d’optimiser la gestion des animaux, améliorer la traçabilité, et assurer un suivi en temps réel des informations liées au cheptel (naissances, ventes, maladies, vaccinations, etc.). Pour accompagner les professionnels du secteur dans leurs défis quotidiens.",
      services: [
        {
          serviceIcon: "Send",
          serviceTitle: "Recensement digitale",
          serviceDescription: "En quelques clics, les éleveurs et les agents peuvent tenir des registres précis, accessibles à tout moment.",
        },
        {
          serviceIcon: "BarChart",
          serviceTitle: "Rapports en temps Réel",
          serviceDescription: "Des rapports qui fournissent des informations stratégiques sur l’état du cheptel, les tendances de croissance, les besoins en ressources, et les risques potentiels.",
        },
        {
          serviceIcon: "Package",
          serviceTitle: "Gestion des besoins",
          serviceDescription: "Aider les autorités à anticiper les besoins locaux, comme l’approvisionnement en nourriture ou en soins vétérinaires, et à planifier efficacement la distribution des ressources.",
        },
      ],
    },
  };

export const INSCRIPTION_DATA = {
  title: "Inscrivez-vous en quelques minutes !",
  description: "Profitez d'une plateforme simple et sécurisée pour suivre et déclarer votre cheptel en toute transparence.",
  advantages: [
    { icon: "CircleCheck", text: "Un accès rapide et sécurisé" },
    { icon: "CircleCheck", text: "Une meilleure traçabilité de votre élevage" }
  ],
  images: {
    [TypeUser.PARTICULIER]: "/assets/images/domestique.png",
    [TypeUser.ENTREPRISE]: "/assets/images/boeuf.png",
  }
};


export const CONNEXION_DATA = {
  title: "Connectez-vous à votre compte",
  description: "Accédez à votre espace personnel et simplifiez la gestion de votre cheptel.",
  advantages: [
    { icon: "CircleCheck", text: "Un accès rapide et sécurisé" },
    { icon: "CircleCheck", text: "Une meilleure traçabilité de votre élevage" }
  ],
  image: "/assets/images/boeuf1.png"
};


export const RECUPERATION_DATA = {
  email: {
    titre: "Je recupère mon accès",
    sousTitre: "Entrez simplement votre adresse e-mail, et on vous enverra un lien pour réinitialiser votre mot de passe en quelques secondes.",
    image: "/assets/images/baobabier.png",
    type: "email",
  },
  code: {
    titre: "Vérification en cours",
    sousTitre: "Nous venons de vous envoyer un code secret.Entrez-le ci-dessous pour sécuriser votre accès.",
    image: "/assets/images/statut.png",
    type: "code",
  },
};



export const MDP_DATA = {
    titre:"Je crée mon nouveau mot de passe",
    sousTitre: "Conseils pour un mot de passe",
    description: [
      "Au moins 8 caractères",
      "Une majuscule, une minuscule",
      "Un chiffre ou un symbole",
    ],
    image: "/assets/images/campagne.png",
  
};


export const CONFIDENTIAITE_DATA = {
  securityMessage: "Vos informations sont sécurisées et restent confidentielles. En vous inscrivant, vous acceptez nos {conditions} et notre {politique}.",
  links: {
    conditions: {
      text: "conditions d’utilisation",
      url: "/conditions"
    },
    politique: {
      text: "politique de confidentialité",
      url: "/politique"
    }
  }
};